import React, { useState, useEffect, useRef, useMemo} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useWebSocket } from "../services/useWebSocket";
import ScoutingBar from "./ScoutingBar";
import CodesList from "./CodesList";
//import { checkSetWin } from "../services/setLogicService";
import apiClient from "../services/apiClient";
import RotationDisplay from "./RotationDisplay"; 
import SetEndDialog from "./SetEndDialog";
import Scoreboard from "./ScoreBoard";
import SetDurationDialog from "./SetDurationDialog";
import TimeoutDisplay from "./TimeoutDisplay"; 
import SubstitutionPanel from "./SubstitutionPanel";
import PenaltyPanel from "./PenaltyPanel";
import VideoChallengePanel from "./VideoChallengePanel";
import RotationPanel from "./RotationPanel";
import MatchHeader from "./MatchHeader";
import LiberoFixDialog from "./LiberoFixDialog";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { useTheme } from "../config/ThemeContext";
import logger from "../utils/logger";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
const zones = [4, 3, 2, 5, 6, 1];

function LiveScoring() {
    const { matchId } = useParams();
    const [ setCodes] = useState([]);
    //const [ setElapsedTime] = useState(0);
    const [matchOver, setMatchOver] = useState(false);
	const [ setWinner, setSetWinner] = useState(null);
    const [showSetDurationDialog, setShowSetDurationDialog] = useState(false);
    const [currentSet, setCurrentSet] = useState(1);
    const [ setSetDuration] = useState(0);
    //const [matchTitle, setMatchTitle] = useState("");
    const [ scoreA, setScoreA] = useState(0);
    const [ scoreB, setScoreB] = useState(0);
	const [ setSetsA] = useState(0);
    const [ setSetsB] = useState(0);
	const [liberoFixPayload, setLiberoFixPayload] = useState(null);
    //const [teamA, setTeamA] = useState({});
    //const [teamB, setTeamB] = useState({});
    //const [rotationA, setRotationA] = useState({});
    //const [rotationB, setRotationB] = useState({});
    //const [servingTeam, setServingTeam] = useState("A");
    //const [rotationHistory, setRotationHistory] = useState([]);
    const [rotationMessage, setRotationMessage] = useState("");
    const actionCodeRef = useRef(null);
	//const [setStatus, setSetStatus] = useState(""); 
	//const [playerCache, setPlayerCache] = useState({}); 
    const [scoutingCodes, setScoutingCodes] = useState([]); 
	const [showEndSetDialog, setShowEndSetDialog] = useState(false);
    //const [flushStatus, setFlushStatus] = useState("");
	const [sets, setSets] = useState({}); // ✅ Ensures `sets` is always an object
	//const [setsWon, setSetsWon] = useState({ teamA: 0, teamB: 0 }); // ✅ Ensures `setsWon` is defined
	const activeSet = sets[currentSet] || {}; // ✅ Get active set safely
    const [activeSubPanel, setActiveSubPanel] = useState(null); // 'teamA' | 'teamB' | null
	const [activePenaltyPanel, setActivePenaltyPanel] = useState(null); // 'teamA' | 'teamB' | null
    const [activeChallengePanel, setActiveChallengePanel] = useState(null); // 'teamA' | 'teamB' | null
	const [showRotationPanel, setShowRotationPanel] = useState(false);
    const [activeTimeoutTeam, setActiveTimeoutTeam] = useState(null);
        const [pendingTimeoutTeam, setPendingTimeoutTeam] = useState(null);
        const [showTimeoutDialog, setShowTimeoutDialog] = useState(false);
        const [isChangeCourt, setChangeCourt] = useState(null); // null = use matchState default
        const [isProcessing, setIsProcessing] = useState(false); // indicates set summary generation

	
	// Whenever rotation updates, make sure all required players exist
const handleRotationUpdate = async (rotationData) => {
    console.log("📥 Received rotation update:", rotationData);

    if (!rotationData || !rotationData.currentSet || !rotationData.rotations) {
        console.error("❌ Invalid rotation data:", rotationData);
        return;
    }

    const { currentSet, rotations } = rotationData;

    // Extract rotations for each team
    const rotationA = rotations.teamA || [];
    const rotationB = rotations.teamB || [];

    // Ensure rotations have exactly 6 players
    if (!Array.isArray(rotationA) || rotationA.length !== 6 ||
        !Array.isArray(rotationB) || rotationB.length !== 6) {
        console.error("❌ Invalid rotation data:", rotationData);
        return;
    }

    // Extract player maps for both teams
	const playerMapA = rotationData.playerMap?.teamA || {};
	const playerMapB = rotationData.playerMap?.teamB || {};
	console.log(`✅ Updated Rotation playerMapA:`, playerMapA);
    // Update rotations in state
    setSets(prevSets => {
        const updatedSets = { ...prevSets };
        if (!updatedSets[currentSet]) updatedSets[currentSet] = {};

        // Format rotations
        const formattedRotationA = Object.fromEntries(
            rotationA.map((playerId, index) => [
                zones[index], 
                playerMapA[playerId] || { id: playerId, shirtNumber: "?", shirtName: "Unknown" }
            ])
        );

        const formattedRotationB = Object.fromEntries(
            rotationB.map((playerId, index) => [
                zones[index], 
                playerMapB[playerId] || { id: playerId, shirtNumber: "?", shirtName: "Unknown" }
            ])
        );

        updatedSets[currentSet] = {
            ...updatedSets[currentSet],
            rotationA: formattedRotationA,
            rotationB: formattedRotationB
        };

        console.log(`✅ Updated Rotation:`, updatedSets[currentSet]);
        return updatedSets;
    });

    setRotationMessage("Rotation updated for both teams.");
    setTimeout(() => setRotationMessage(""), 2000);
};

	
const {
        socket,
		matchState,
		setMatchState,
		//playerMap,
        //timeouts,
        isTimeoutActive,
        timeoutDuration,
		timeoutType,
        //requestTimeout,
		requestTeamTimeout,
    } = useWebSocket(
        matchId,
        setCodes,
        setScoreA,
        setScoreB,
        setSetsA,
        setSetsB,
        setCurrentSet,
        setMatchOver,
        setShowEndSetDialog,
        setScoutingCodes,
        //setRotationA,
        //setRotationB,
        setSetDuration,
        setShowSetDurationDialog,
        handleRotationUpdate,
		setSetWinner 
    );
	//console.log("🛜 [DEBUG] playerMap in LiveScoring.js:", JSON.stringify(playerMap, null, 2));
    //console.log("🛜 [DEBUG] handleRotationUpdate in LiveScoring.js:", handleRotationUpdate);
	// Determine layout direction
const shouldFlipA = useMemo(() => {
  if (!matchState || !matchState.sideIndicator) return false;
  return isChangeCourt !== null
    ? isChangeCourt
    : matchState.sideIndicator.left === "teamB";
}, [matchState, isChangeCourt]);

const shouldFlipB = useMemo(() => {
  if (!matchState || !matchState.sideIndicator) return false;
  return isChangeCourt !== null
    ? !isChangeCourt
    : matchState.sideIndicator.left === "teamA";
}, [matchState, isChangeCourt]);

const shouldFlip = shouldFlipA; // Used for center scoreboard for now

    const colors = useTheme();
	const navigate = useNavigate(); // ✅ Define navigate properly

    useEffect(() => {
        if (!socket) return;

        const handleConfirmSetEnd = (data) => {
            console.log("📥 Received confirmSetEnd event:", data);
            setShowEndSetDialog(true); // ✅ Show SetEndDialog when event is received
        };

        socket.on("confirmSetEnd", handleConfirmSetEnd);
		const handleLiberoRotationBlocked = (payload) => {
		  console.warn("🛑 Libero rotation blocked:", payload);
		  setLiberoFixPayload(payload);
		};
		socket.on("liberoRotationBlocked", handleLiberoRotationBlocked);

        return () => {
            socket.off("confirmSetEnd", handleConfirmSetEnd);
		    socket.off("liberoRotationBlocked", handleLiberoRotationBlocked);
        };
    }, [socket]);

useEffect(() => {
  const fetchUpdatedMatchState = async () => {
    try {
      const response = await apiClient.get(`/api/matches/${matchId}/matchState`);
      setMatchState(response.data);

      // Also reset local timer display if you use one:
      //setElapsedTime(0);
    } catch (err) {
      console.error("❌ Failed to fetch updated match state after set start:", err);
    }
  };

  if (matchId && currentSet) {
    fetchUpdatedMatchState();
  }
}, [matchId, currentSet]); // 🚨 Triggered when navigating to new set

useEffect(() => {
  if (matchOver && showSetDurationDialog) {
    setShowSetDurationDialog(false);
  }
}, [matchOver, showSetDurationDialog]);

// Hide processing overlay when summary dialog appears
useEffect(() => {
  if (showSetDurationDialog) {
    setIsProcessing(false);
  }
}, [showSetDurationDialog]);
    




const handleScoreChange = (team, change, setMatchState, matchState, socket) => {
    console.log(`Handling score change for ${team}, change: ${change}`);

    if (!setMatchState) {
        console.error("❌ Cannot update score: setMatchState is undefined.");
        return;
    }

    const currentSet = matchState?.currentSet;
    if (!matchState?.sets?.[currentSet]) {
        console.error(`❌ Set ${currentSet} does not exist in matchState.sets!`);
        return;
    }

    // ✅ Fix Bug 3: Emit socket event OUTSIDE the state updater (updaters must be pure functions).
    // Send delta (team + change) instead of absolute scores so the server applies it to latest state.
    console.log(`📡 Emitting scoreUpdate for match ${matchState.matchId}, Set ${currentSet}`);
    socket.emit("scoreUpdate", {
        matchId: matchState.matchId,
        currentSet,
        team,
        change,
    });

    // ✅ Fix Bug 2: Proper immutable deep copy of nested sets object.
    // The old shallow spread ({ ...prevState }) shared the nested sets reference,
    // causing in-place mutation of the previous state.
    setMatchState(prevState => {
        if (!prevState) return prevState;

        const cs = prevState.currentSet;
        if (!prevState.sets?.[cs]) return prevState;

        const prevSetData = prevState.sets[cs];
        return {
            ...prevState,
            sets: {
                ...prevState.sets,
                [cs]: {
                    ...prevSetData,
                    scoreA: team === "teamA"
                        ? Math.max(0, prevSetData.scoreA + change)
                        : prevSetData.scoreA,
                    scoreB: team === "teamB"
                        ? Math.max(0, prevSetData.scoreB + change)
                        : prevSetData.scoreB,
                }
            }
        };
    });
};

const handleTimeoutClick = (team) => {
    setPendingTimeoutTeam(team);
    setShowTimeoutDialog(true);
  };

const confirmTimeout = () => {
  if (pendingTimeoutTeam) {
    requestTeamTimeout(pendingTimeoutTeam);
    setActiveTimeoutTeam(pendingTimeoutTeam); // ✅ Track it here
  }
  setPendingTimeoutTeam(null);
  setShowTimeoutDialog(false);
};


  const cancelTimeout = () => {
    setPendingTimeoutTeam(null);
    setShowTimeoutDialog(false);
  };




//Displays the set summary
const handleSetDurationSubmit = (duration) => {
    setShowSetDurationDialog(false);

    // ✅ Send set duration to backend
    //socket.emit("setDurationSubmit", { matchId, setDuration: duration });
    //console.log("📤 Set duration submitted:", duration);
    // ✅ Ensure `currentSet` is a valid number
    const nextSetNumber = Number(currentSet) + 1;

    if (!matchOver && !isNaN(nextSetNumber)) {
        console.log(`🔄 Navigating to PreSetSetup for set ${nextSetNumber}`);
        navigate(`/matches/pre-set/${matchId}/${nextSetNumber}`);
    } else {
        console.warn("⚠️ Navigation prevented due to invalid currentSet or match being over.");
    }
};

/** ✅ Handles user decision when SetEndDialog is shown */
	const handleConfirmSetEnd = (confirmed) => {
	  if (confirmed) {
			setIsProcessing(true); // show processing overlay
			console.log("✅ Set confirmed. Sending setHasEnded...");
			socket.emit("setHasEnded", {
			  matchId,
			  winner: setWinner, // use saved winner from confirmSetEnd
			  setDuration: activeSet.elapsedTime ?? 0,
			});
	  }
	  setShowEndSetDialog(false);
	};
	
    return (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
    {/* Compact Header */}
    <div className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <MatchHeader
        teamAName={matchState?.teams?.teamA?.name || "Team A"}
        teamBName={matchState?.teams?.teamB?.name || "Team B"}
        currentSet={currentSet}
        matchId={matchId}
        socket={socket}
      />
    </div>

    {/* Compact Dashboard - No scrolling needed */}
    <div className="container mx-auto px-4 py-3 space-y-3">
      {/* Match Over Banner */}
      {matchOver && (
        <div className="
          bg-gradient-to-r from-green-500 to-emerald-600
          text-white rounded-xl p-4 shadow-lg
          border border-green-400
        ">
          <h2 className="text-2xl font-bold mb-2 flex items-center gap-2">
            🏆 Match Completed
          </h2>
          <div className="flex flex-wrap gap-3">
            <button
              className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg font-semibold transition-all duration-200"
              onClick={() => window.open(`${API_BASE_URL}/api/matches/${matchId}/report`, "_blank")}
            >
              📋 P2 Report
            </button>
            <button
              className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg font-semibold transition-all duration-200"
              onClick={() => window.open(`${API_BASE_URL}/api/matches/${matchId}/player-skill-report`, "_blank")}
            >
              ⭐ P3 Ranking
            </button>
            <button
              className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg font-semibold transition-all duration-200"
              onClick={() => navigate(`/`)}
            >
              🏠 Home
            </button>
          </div>
        </div>
      )}

      {/* Main Content Grid - Split into 2/3 main panel and 1/3 scouting */}
      <div className="grid grid-cols-3 gap-3 h-[calc(100vh-140px)]">
        
        {/* Main Panel - 2/3 width */}
        <div className="col-span-2 flex flex-col space-y-3">
          {/* First Row - Scoreboard and Team Controls */}
          <div className={`flex items-start ${shouldFlip ? 'flex-row-reverse space-x-reverse' : ''} space-x-3`}>
            {/* Team A Controls */}
            <div className="w-48 bg-white/80 backdrop-blur-sm rounded-xl p-2 border border-white/20 shadow-lg">
              <div className="text-center mb-2">
                <h3 className="text-lg font-bold text-blue-700">
                  {matchState?.teams?.teamA?.code || "Team A"}
                </h3>
              </div>
              <div className="flex flex-col space-y-2">
                {/* Primary Actions */}
                <button
                  className={`
                    p-2 rounded-lg text-center transition-all duration-200
                    ${colors.teamA.bg} ${colors.teamA.border} ${colors.teamA.text}
                    hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300
                    ${isTimeoutActive ? "opacity-50 pointer-events-none" : ""}
                    text-base font-semibold
                  `}
                  onClick={() => handleTimeoutClick("teamA")}
                >
                  <div className="flex items-center justify-center gap-1 mb-1">
                    <span className="text-xl">⏱️</span>
                    <span>Timeout</span>
                  </div>
                  <div className="text-lg font-bold opacity-75">
                    {matchState?.sets[currentSet]?.timeout?.teamA ?? 0}
                  </div>
                </button>
                
                <button
                  className={`
                    p-2 rounded-lg text-center transition-all duration-200
                    ${colors.teamA.bg} ${colors.teamA.border} ${colors.teamA.text}
                    hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300
                    text-base font-semibold
                  `}
                  onClick={() => setActiveSubPanel("teamA")}
                >
                  <div className="flex items-center justify-center gap-1 mb-1">
                    <span className="text-xl">🔃</span>
                    <span>Sub</span>
                  </div>
                  <div className="text-lg font-bold opacity-75">
                    {matchState?.sets[currentSet]?.substitution?.teamA ?? 0}
                  </div>
                </button>

                {/* Secondary Actions - Collapsible */}
                <details className="group">
                  <summary className="text-xs text-gray-500 cursor-pointer hover:text-gray-700 py-1 flex items-center justify-center">
                    <span className="mr-1">More Actions</span>
                    <svg className="w-4 h-4 transition-transform group-open:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </summary>
                  <div className="pt-1 space-y-1">
                    <button
                      className={`
                        w-full p-1.5 rounded-lg text-center transition-all duration-200
                        ${colors.teamA.bg} ${colors.teamA.border} ${colors.teamA.text}
                        hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300
                        text-sm font-semibold
                      `}
                      onClick={() => setActiveChallengePanel("teamA")}
                    >
                      <div className="flex items-center justify-center gap-1 mb-1">
                        <span className="text-base">📽️</span>
                        <span>Challenge</span>
                      </div>
                      <div className="text-base font-bold opacity-75">
                        {matchState?.sets[currentSet]?.challengeNOK?.teamA ?? 0}
                      </div>
                    </button>
                    
                    <button
                      className={`
                        w-full p-1.5 rounded-lg text-center transition-all duration-200
                        ${colors.teamA.bg} ${colors.teamA.border} ${colors.teamA.text}
                        hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300
                        text-sm font-semibold
                      `}
                      onClick={() => setActivePenaltyPanel("teamA")}
                    >
                      <div className="flex items-center justify-center gap-1 mb-1">
                        <span className="text-base">🚩</span>
                        <span>Penalty</span>
                      </div>
                    </button>
                  </div>
                </details>
              </div>
            </div>

            {/* Compact Scoreboard */}
            <div>
              <Scoreboard
                matchState={matchState}
                currentSet={currentSet}
                shouldFlip={shouldFlip}
                handleScoreChange={(team, change) =>
                  handleScoreChange(team, change, setMatchState, matchState, socket)}
                compactMode={true}
              />
            </div>

            {/* Team B Controls */}
            <div className="w-48 bg-white/80 backdrop-blur-sm rounded-xl p-2 border border-white/20 shadow-lg">
              <div className="text-center mb-2">
                <h3 className="text-lg font-bold text-orange-700">
                  {matchState?.teams?.teamB?.code || "Team B"}
                </h3>
              </div>
              <div className="flex flex-col space-y-2">
                {/* Primary Actions */}
                <button
                  className={`
                    p-2 rounded-lg text-center transition-all duration-200
                    ${colors.teamB.bg} ${colors.teamB.border} ${colors.teamB.text}
                    hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300
                    ${isTimeoutActive ? "opacity-50 pointer-events-none" : ""}
                    text-base font-semibold
                  `}
                  onClick={() => handleTimeoutClick("teamB")}
                >
                  <div className="flex items-center justify-center gap-1 mb-1">
                    <span className="text-xl">⏱️</span>
                    <span>Timeout</span>
                  </div>
                  <div className="text-lg font-bold opacity-75">
                    {matchState?.sets[currentSet]?.timeout?.teamB ?? 0}
                  </div>
                </button>
                
                <button
                  className={`
                    p-2 rounded-lg text-center transition-all duration-200
                    ${colors.teamB.bg} ${colors.teamB.border} ${colors.teamB.text}
                    hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300
                    text-base font-semibold
                  `}
                  onClick={() => setActiveSubPanel("teamB")}
                >
                  <div className="flex items-center justify-center gap-1 mb-1">
                    <span className="text-xl">🔃</span>
                    <span>Sub</span>
                  </div>
                  <div className="text-lg font-bold opacity-75">
                    {matchState?.sets[currentSet]?.substitution?.teamB ?? 0}
                  </div>
                </button>

                {/* Secondary Actions - Collapsible */}
                <details className="group">
                  <summary className="text-xs text-gray-500 cursor-pointer hover:text-gray-700 py-1 flex items-center justify-center">
                    <span className="mr-1">More Actions</span>
                    <svg className="w-4 h-4 transition-transform group-open:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </summary>
                  <div className="pt-1 space-y-1">
                    <button
                      className={`
                        w-full p-1.5 rounded-lg text-center transition-all duration-200
                        ${colors.teamB.bg} ${colors.teamB.border} ${colors.teamB.text}
                        hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300
                        text-sm font-semibold
                      `}
                      onClick={() => setActiveChallengePanel("teamB")}
                    >
                      <div className="flex items-center justify-center gap-1 mb-1">
                        <span className="text-base">📽️</span>
                        <span>Challenge</span>
                      </div>
                      <div className="text-base font-bold opacity-75">
                        {matchState?.sets[currentSet]?.challengeNOK?.teamB ?? 0}
                      </div>
                    </button>
                    
                    <button
                      className={`
                        w-full p-1.5 rounded-lg text-center transition-all duration-200
                        ${colors.teamB.bg} ${colors.teamB.border} ${colors.teamB.text}
                        hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-300
                        text-sm font-semibold
                      `}
                      onClick={() => setActivePenaltyPanel("teamB")}
                    >
                      <div className="flex items-center justify-center gap-1 mb-1">
                        <span className="text-base">🚩</span>
                        <span>Penalty</span>
                      </div>
                    </button>
                  </div>
                </details>
              </div>
            </div>
          </div>

          {/* Substitution Panel */}
          {activeSubPanel && (
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg mb-3">
              <SubstitutionPanel
                team={activeSubPanel}
                currentSet={currentSet}
                playerMap={matchState.playerMap}
                rotation={matchState.sets?.[currentSet]?.[`rotation${activeSubPanel.charAt(4).toUpperCase()}`] ?? []}
                subs={matchState.sets?.[currentSet]?.substitution?.[activeSubPanel] ?? 0}
                teamName={matchState.teams?.[activeSubPanel]?.name ?? "Unknown Team"}
                matchId={matchId}
                socket={socket}
                matchState={matchState}
                onClose={() => setActiveSubPanel(null)}
              />
            </div>
          )}

          {/* Challenge Panel */}
          {activeChallengePanel && (
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg mb-3">
              <VideoChallengePanel
                team={activeChallengePanel}
                currentSet={currentSet}
                challengeOK={matchState.sets?.[currentSet]?.challengeOK?.[activeChallengePanel] ?? 0}
                challengeNOK={matchState.sets?.[currentSet]?.challengeNOK?.[activeChallengePanel] ?? 0}
                matchId={matchId}
                socket={socket}
                teamName={matchState.teams?.[activeChallengePanel]?.name ?? "Unknown Team"}
                onClose={() => setActiveChallengePanel(null)}
              />
            </div>
          )}

          {/* Penalty Panel */}
          {activePenaltyPanel && (
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg mb-3">
              <PenaltyPanel
                matchId={matchId}
                team={activePenaltyPanel}
                teamName={matchState.teams[activePenaltyPanel]?.name || ""}
                currentSet={currentSet}
                matchState={matchState}
                socket={socket}
                onClose={() => setActivePenaltyPanel(null)}
              />
            </div>
          )}

          {/* Third Row - Rotations */}
          <div className="flex-1 bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg">
            {/* Current Rotations */}
            <div className={`
              flex flex-row justify-center gap-2 items-center
              ${shouldFlip ? "flex-row-reverse" : ""}
            `}>
              <div className="flex-1">
                <RotationDisplay 
                  teamName={matchState?.teams?.teamA?.code || "Team A"} 
                  rotation={matchState?.sets?.[currentSet]?.rotationA ?? []}
                  playerMap={matchState?.playerMap?.teamA ?? {}}
                  isServing={Number(matchState?.sets?.[currentSet]?.servingTeam) === matchState?.teams?.teamA?.id}
                  team="teamA"
                  matchId={matchId}
                  currentSet={currentSet}
                  socket={socket}
                  showRotationControls={true}
                  shouldFlip={shouldFlip} 
                  liberoIds={matchState?.sets?.[currentSet]?.liberoIds?.teamA ?? []}
                />
              </div>

              {/* Flip Court Button */}
              <button
                onClick={() => setChangeCourt((prev) => prev === null ? true : !prev)}
                className="
                  px-1 py-1.5 rounded-lg
                  bg-gray-100 hover:bg-gray-200
                  text-gray-700
                  transition-all duration-200
                  focus:outline-none focus:ring-2 focus:ring-gray-300
                  self-start mt-4
                "
                title="Change court orientation"
              >
                <span className="text-lg" title="Change court">↔️</span>
              </button>

              <div className="flex-1">
                <RotationDisplay 
                  teamName={matchState?.teams?.teamB?.code || "Team B"} 
                  rotation={matchState?.sets?.[currentSet]?.rotationB ?? []}
                  playerMap={matchState?.playerMap?.teamB ?? {}}
                  isServing={Number(matchState?.sets?.[currentSet]?.servingTeam) === matchState?.teams?.teamB?.id}
                  team="teamB"
                  matchId={matchId}
                  currentSet={currentSet}
                  socket={socket}
                  showRotationControls={true}
                  shouldFlip={shouldFlip}
                  liberoIds={matchState?.sets?.[currentSet]?.liberoIds?.teamB ?? []}	  
                />
              </div>
            </div>

            {/* Rotation History Toggle Button */}
            {matchState?.sets[currentSet]?.rotationHistory && (
              <div className="mt-3 flex justify-center">
                <button
                  onClick={() => setShowRotationPanel(v => !v)}
                  className="
                    group px-3 py-1.5 rounded-lg
                    bg-gray-100 hover:bg-gray-200
                    text-gray-700 font-medium text-sm
                    transition-all duration-200
                    focus:outline-none focus:ring-2 focus:ring-gray-300
                    flex items-center gap-2
                  "
                >
                  <span>Rotation History</span>
                  <svg 
                    className={`w-4 h-4 transition-transform duration-200 ${showRotationPanel ? 'rotate-180' : ''}`}
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            )}

            {/* Rotation History Panel */}
            {showRotationPanel && matchState?.sets[currentSet]?.rotationHistory && (
              <div className="mt-3 border-t border-gray-200 pt-3">
                <RotationPanel
                  visible={true}
                  onToggle={() => setShowRotationPanel(v => !v)}
                  rotationHistory={matchState.sets[currentSet].rotationHistory}
                  playerMapA={matchState.playerMap.teamA}
                  playerMapB={matchState.playerMap.teamB}
                  teamAName={matchState.teams.teamA.code}
                  teamBName={matchState.teams.teamB.code}
                  hidden={false}
                />
              </div>
            )}
          </div>
        </div>

        {/* Scouting Panel - 1/3 width */}
        <div className="col-span-1 flex flex-col space-y-3">
          {/* Scouting Input */}
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg">
            <ScoutingBar
              matchId={matchId}
              setId={currentSet}
              elapsedTime={activeSet.elapsedTime ?? 0}
              inputRef={actionCodeRef}
              socket={socket}
			onNewEntry={(entry) => {
				logger.trace("📥 [TRACE] LiveScoring: Received onNewEntry call", entry);
				setScoutingCodes(prev => {
				  logger.trace("🔄 [TRACE] LiveScoring: setScoutingCodes reducer. Prev count:", prev?.length);
				  if (!Array.isArray(prev)) {
					logger.trace("❌ [TRACE] LiveScoring: prev is NOT an array!", prev);
					return [entry];
				  }
				  
				  const exists = prev.some(c => c.uuid === entry.uuid);
				  if (exists) {
					logger.trace("ℹ️ [TRACE] LiveScoring: Entry with uuid exists, updating. UUID:", entry.uuid);
					return prev.map(c => c.uuid === entry.uuid ? entry : c);
				  }
				  
				  const latestRallyId = prev.reduce(
					(max, c) => Math.max(max, c.rallyId || 0),
					0
				  );
				  logger.trace("🆕 [TRACE] LiveScoring: Adding new entry. Latest RallyId:", latestRallyId);
				  return [...prev, { ...entry, rallyId: latestRallyId }];
				});
			  }}
			/>
          </div>

          {/* Recent Events - Takes remaining height */}
          <div className="flex-1 bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/20 shadow-lg overflow-auto">
            <CodesList
              codes={scoutingCodes}
              setCodes={setScoutingCodes}
              socket={socket}
              matchId={matchId}
              setNumber={currentSet}
              compact={true}
            />
          </div>
        </div>
      </div>

      {/* Bottom Row - Events History (if needed) */}
      {/* Removed as per edit hint */}
    </div>

    {/* Modals and Dialogs */}
    <SetEndDialog show={showEndSetDialog} currentSet={currentSet} onConfirm={handleConfirmSetEnd} />
    <SetDurationDialog
      show={showSetDurationDialog}
      matchId={matchId}
      currentSet={currentSet}
      setDuration={activeSet.elapsedTime ?? 0}
      setSetDuration={setSetDuration}
      matchOver={matchOver} 
      onConfirm={handleSetDurationSubmit}
    />

    {liberoFixPayload && (
      <LiberoFixDialog
        matchId={matchId}
        setNumber={currentSet}
        team={liberoFixPayload.team}
        activeLiberoId={liberoFixPayload.activeLiberoId}
        replacedPlayerId={liberoFixPayload.replacedPlayerId}
        actionCode={liberoFixPayload.actionCode}
        playerMap={matchState?.playerMap}
        rotation={matchState?.sets?.[currentSet]?.[`rotation${liberoFixPayload.team.charAt(4).toUpperCase()}`] || []}
        socket={socket}
        onClose={() => {
          setLiberoFixPayload(null);
          setTimeout(() => {
            actionCodeRef?.current?.focus();
          }, 100);
        }}
      />
    )}

    {showTimeoutDialog && pendingTimeoutTeam && (
      <ConfirmationDialog
        isOpen={true}
        title="Confirm Timeout"
        message={`Are you sure you want to call a timeout for ${matchState?.teams?.[pendingTimeoutTeam]?.code || "Unknown Team"}?`}
        onConfirm={confirmTimeout}
        onCancel={cancelTimeout}
        confirmText="Yes, call timeout"
        cancelText="Cancel"
      />
    )}

    <TimeoutDisplay
      isTimeoutActive={isTimeoutActive}
      timeoutDuration={timeoutDuration}
      timeoutType={timeoutType}
      timeoutTeamName={
        timeoutType === "TEAM"
          ? matchState?.teams?.[activeTimeoutTeam]?.code || "Unknown Team"
          : ""
      }
    />

    {isProcessing && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="text-white text-center">
          <svg className="animate-spin h-10 w-10 mb-4" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4z"></path>
          </svg>
          <p className="text-lg font-medium">Generating Set Summary...</p>
        </div>
      </div>
    )}
  </div>
);

	
}

export default LiveScoring;